import { decodeHtmlEntities } from './decodeHtmlEntities';
import { removeHtmlTags } from './removeHtmlTags';

function replaceMultipleSpaces(text: string): string {
    return text.replace(/ {2,}/g, ' ');
}

function replaceBrWithNewLine(text: string): string {
    return text.replace(/<br\s*\/?>/gi, '\n');
}

function replaceEndBlockBySpace(text: string): string {
    return text.replace(
        /<\/(p|div|section|article|header|footer|ul|ol|li|h1|h2|h3|h4|h5|h6)>/gi,
        ' ',
    );
}

export function htmlToText(html: string): string {
    let text = replaceBrWithNewLine(html);

    text = replaceEndBlockBySpace(text);
    text = replaceMultipleSpaces(text);
    text = decodeHtmlEntities(text);
    text = removeHtmlTags(text);

    return text.trim();
}
